/* eslint-disable import/order */
import Vue from 'vue';

import AdminApp from './AdminApp.vue';

import router from './AdminRouter';
import fb from '../firebaseConfig';

import '../styles/index.scss';
import vuetify from '../plugins/vuetify';

/* eslint-enable import/order */
Vue.config.productionTip = false;

let app;
fb.auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      vuetify,
      render: h => h(AdminApp),
    }).$mount('#app');
  }
});
